import { useState } from 'react';

import type { TagSheetParseResult, TagSheetSaveResult } from '../../types';
import type { UseUploadTagSheetResponse } from '../types';

const useUploadTagSheet = (): UseUploadTagSheetResponse => {
  const [parseResult, setParseResult] = useState<TagSheetParseResult | null>(null);
  const [savedTagSheetResult, setSavedTagSheetResult] = useState<TagSheetSaveResult | null>(null);

  return {
    parseResult,
    setParseResult,
    savedTagSheetResult,
    setSavedTagSheetResult,
  };
};

export default useUploadTagSheet;
